import { QUOTA_PERIOD } from '@/types/quota-period';

/** "por semana" / "por mês" — a janela em que a cota se renova. */
export function quotaPeriodLabel(period: QUOTA_PERIOD): string {
  return period === QUOTA_PERIOD.WEEK ? 'por semana' : 'por mês';
}

/** "nesta semana" / "neste mês" — a janela corrente, para falar de saldo. */
export function quotaPeriodNow(period: QUOTA_PERIOD): string {
  return period === QUOTA_PERIOD.WEEK ? 'nesta semana' : 'neste mês';
}

/** "3 sessões por semana", "1 sessão por mês". */
export function formatQuota(sessions: number, period: QUOTA_PERIOD): string {
  const unit = sessions === 1 ? 'sessão' : 'sessões';
  return `${sessions} ${unit} ${quotaPeriodLabel(period)}`;
}

/** Saldo em linguagem de gente: "Restam 2 de 3 nesta semana". */
export function formatQuotaBalance(
  remaining: number,
  quota: number,
  period: QUOTA_PERIOD,
): string {
  if (remaining <= 0) {
    return `Você já usou as ${quota} ${quota === 1 ? 'sessão' : 'sessões'} ${quotaPeriodNow(period)}`;
  }
  return `Resta${remaining === 1 ? '' : 'm'} ${remaining} de ${quota} ${quotaPeriodNow(period)}`;
}
